var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13C10.7614 13 13 10.7614 13 8C13 5.23858 10.7614 3 8 3C5.23858 3 3 5.23858 3 8C3 10.7614 5.23858 13 8 13ZM7.25 10.25C7.25 9.83579 7.58579 9.5 8 9.5C8.41421 9.5 8.75 9.83579 8.75 10.25C8.75 10.6642 8.41421 11 8 11C7.58579 11 7.25 10.6642 7.25 10.25ZM7.50806 5.41012C7.55039 5.17688 7.75454 5 8 5C8.24546 5 8.44961 5.17688 8.49194 5.41012L8.5 5.5V8L8.49194 8.08988C8.44961 8.32312 8.24546 8.5 8 8.5C7.75454 8.5 7.55039 8.32312 7.50806 8.08988L7.5 8V5.5L7.50806 5.41012Z",
    fill: "#BF6A3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.9438bacd9fc8d39846518653fe4c0c9e.svg";
export { ForwardRef as ReactComponent };